// React Query обвивките за инвентаризациите, добавени с редизайна. Всички
// ключове са под ["inventory", "stocktakes", …] — `invalidateAll`
// (useInventory.ts) и записът на инвентаризация ги опресняват наведнъж.
import { useMutation, useQueries, useQuery, useQueryClient } from "@tanstack/react-query";
import { getStocktake } from "../api/inventory";
import {
  annulStocktake,
  getLatestStocktakes,
  getStocktakesReport,
  type StocktakesReportParams,
} from "../api/inventoryStocktakes";
import { useIsEdgeLocal } from "./useEdgeMode";
import { invalidateAll } from "./useInventory";

export const useStocktakesReport = (params: StocktakesReportParams | null) =>
  useQuery({
    queryKey: ["inventory", "stocktakes", "report", params],
    queryFn: () => getStocktakesReport(params!),
    enabled: !!params,
  });

// Последната инвентаризация по склад. Новият endpoint мълчи в локален режим
// (касата го няма); до BE без него (404) списъкът е празен.
export const useLatestStocktakes = () => {
  const isLocal = useIsEdgeLocal();
  return useQuery({
    queryKey: ["inventory", "stocktakes", "latest"],
    queryFn: getLatestStocktakes,
    enabled: !isLocal,
    retry: false,
  });
};

// Пълните документи на няколко инвентаризации (разликата в стойност на
// последната по склад). Малко на брой — по една на склад.
export const useStocktakeDocuments = (ids: number[]) =>
  useQueries({
    queries: ids.map((id) => ({
      queryKey: ["inventory", "stocktakes", "document", id],
      queryFn: () => getStocktake(id),
      staleTime: 60_000,
    })),
  });

export const useAnnulStocktake = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, reason }: { id: number; reason: string | null }) =>
      annulStocktake(id, reason),
    onSuccess: () => invalidateAll(qc),
  });
};
